import { DungChungService } from 'app/views/pages/nfc/dung-chung/__services/dung-chung.service';
import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef, Inject, ViewRef, ViewChild, ElementRef } from '@angular/core';
import { MatPaginator, MatSort, MatDialog, MatTableDataSource, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { BehaviorSubject, Subscription } from 'rxjs';
import { LayoutUtilsService, QueryParamsModel } from 'app/core/_base/crud';
import { CommonConFig } from 'app/views/pages/nfc/dung-chung/__model/common_config.model';
import { ActivatedRoute, Router } from '@angular/router';
import { SubheaderService } from 'app/core/_base/layout';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FileImport } from 'app/views/pages/nfc/dung-chung/__model/file-import.model';
import { TokenStorage } from 'app/core/auth/_services/token-storage.service';
import moment from 'moment';
import _ from 'lodash';
import { ColumnsListDocumentInSystem } from '../yeu-cau-mua-shared/yeu-cau-mua.model';
import { FShareService } from '../../danh-muc/fshare/fshare.service';
@Component({
	selector: 'kt-danh-sach-tai-lieu',
	templateUrl: './danh-sach-tai-lieu.component.html',
	//styleUrls: ['../qltl-tlnb.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListDocumentInSystemComponent implements OnInit, OnDestroy {
	// CONFIG
	CONFIG : CommonConFig;
	private componentSubscriptions: Subscription;

	// TABLE
	displayedColumns: string[] = ColumnsListDocumentInSystem.map(_col => _col.name);
	dataSource = [];
    documents : any[] = [];
	receiveData = new BehaviorSubject<boolean>(false);

	// EMPTY
	readonly TITLE = "Thông tin tài liệu";
	readonly SUBTITLE = "Không có dữ liệu";
	readonly DESCRIPTION = "Vui lòng thêm dữ liệu tài liệu ở menu <i style='color: blue'>Tài liệu nội bộ</i>";

	constructor(
		public dialogRef: MatDialogRef<ListDocumentInSystemComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialog: MatDialog,
		private layoutUtilsService: LayoutUtilsService,
		private changeDetectorRefs: ChangeDetectorRef,
		private fshareService: FShareService,
		private changeDetect:ChangeDetectorRef,
		private route: ActivatedRoute,
		private router: Router,
		private subheaderService: SubheaderService,
		private commonService: DungChungService,
		private fileFormFB: FormBuilder,
		private mainFormFB: FormBuilder,
		private tokenStorage: TokenStorage,
		private el: ElementRef,
		) {dialogRef.disableClose = true;}

	ngOnInit() {
		this.CONFIG = new CommonConFig();
		let _query = new QueryParamsModel({},'asc', '', 0, 10, {}, true);
		this.fshareService.loadDocuments(_query).subscribe(res => {
			if(res && res.status == 1){
				this.documents = res.data ? [] : [];
				this.receiveData.next(true);
				this.documents = [...this.documents];
				this.changeDetect.detectChanges();
			}else{
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}

	ngOnDestroy() {
		if (this.componentSubscriptions) {
			this.componentSubscriptions.unsubscribe();
		}
	}

	getTitle(){
		return 'DANH SÁCH TÀI LIỆU HIỆN CÓ TRÊN HỆ THỐNG';
	}

	download_file(i: number, item: FileImport) {
		if (item.idLoaiHH > 0) {
			this.fshareService.downloadFile(item.idLoaiHH).subscribe(
				(blob) => {
					var downloadLink = document.createElement("a");
					var url = URL.createObjectURL(blob);
					downloadLink.href = url;
					downloadLink.download = item.filename;
					document.body.appendChild(downloadLink);
					downloadLink.click();
					document.body.removeChild(downloadLink);
				}
			);
		} else {
			let objectURL;
			const file = item.fileByte;
			objectURL = URL.createObjectURL(file);
			var downloadLink = document.createElement("a");
			downloadLink.href = objectURL;
			downloadLink.download = item.filename;
			document.body.appendChild(downloadLink);
			downloadLink.click();
			document.body.removeChild(downloadLink);
		}
	}

	back(){
		this.dialogRef.close({});
	}

	getFormatDate(v: string = '') {
		if (v != '') {
			return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
		}
		return '';
	}

	navigateRouter(url: string){
		this.router.navigateByUrl(url, {
			relativeTo: this.route,
		});
	}
}
